<div class="button-container" [ngClass]="{disabled: disabled}">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.35 47.81">
    <g id="a0379ab9-8283-4e60-bd53-c602adcee6e4" data-name="Layer 2">
      <g id="e6501157-5d35-486b-bb07-8b22bcbdeb6b" data-name="Mini game - Multiple choice">
        <g id="f32cc0c2-7d75-4e20-9e06-27f0f6d102d8" data-name="button_fout">
          <g id="bab1b1a5-4d52-42aa-9cb5-55751eb58219" data-name="button_down">
            <g style="opacity:0.199996992945671">
              <path d="M154,7,6.22,7.11l1.87,35s39.6-2.75,71.54-2.75,72.63,2.75,72.63,2.75Z" />
            </g>
            <polygon points="152.2 7.57 8.09 7.64 8.15 33.57 152.26 33.5 152.2 7.57" style="fill:#870031" />
            <path d="M8.09,7.64,152.2,7.57l.06,25.93-144.1.07ZM158.75,1,1.51,1.07,1.6,40.15l157.25-.08Z"
              style="fill:#e3e1db" />
          </g>
          <g id="f16eec73-96d1-4e93-a201-2c589c97110f" data-name="button_up">
            <g style="opacity:0.2">
              <path d="M155.3,6.35,5,6.43l5.09,35L11,47.81s34.38-6.13,68-6.13,70.48,6,70.48,6l.9-6.41Z" />
            </g>
            <polygon points="153.36 6.92 6.93 6.99 7 34.29 153.43 34.22 153.36 6.92" style="fill:#b00040" />
            <path d="M6.93,7l146.43-.07.07,27.3L7,34.29ZM160.26,0,0,.08.1,41.21l160.25-.08Z" style="fill:#fff" />
          </g>
        </g>
      </g>
    </g>
  </svg>
  <div class="button-caption"><span>{{caption}}<ng-content></ng-content></span></div>
</div>
